import { render, staticRenderFns } from "./SuburbReportDetail.vue?vue&type=template&id=78148bc4&scoped=true&"
import script from "./SuburbReportDetail.vue?vue&type=script&lang=ts&"
export * from "./SuburbReportDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78148bc4",
  null
  
)

export default component.exports